export default function ($) {

  // https://select2.org/getting-started/basic-usage

  $.fn.select2.amd.define('select2/i18n/fr', [], function () {
    return {
      errorLoading: function () {
        return 'Une erreur est survenue, veuillez réessayer.';
      },
      inputTooShort: function (args) {
        return "Merci de saisir au moins " + args.minimum + " caractères";
      },
      inputTooLong: function (args) {
        return "Merci de saisir au plus " + args.minimum + " caractères";
      },
      loadingMore: function () {
        return "Charger plus de résultats";
      },
      noResults: function () {
        return "Aucun résultat, veuillez essayer d'autres mots clefs";
      },
      searching: function () {
        return 'Recherche en cours...';
      }
    }
  })

}
